











import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class TripDirectionsSelect extends Vue {
  selectedTripDirections: number;

  @Prop({ required: true }) value: number | null;
 
  @Watch('value', { immediate: true }) onValueChanged() {
    if (this.value === null || this.value === undefined) {
      return this.selectTripDirections(0);
    }
    this.selectedTripDirections = this.value;
  }

  get tripDirections() {
    return [
      {
        text: this.$i18n.translate('transportationPermission.tripDirections.twoWay', 'Two way'),
        value: 0,
      },
      {
        text: this.$i18n.translate('transportationPermission.tripDirections.departure', 'Departure'),
        value: 1,
      },
      {
        text: this.$i18n.translate('transportationPermission.tripDirections.return', 'Return'),
        value: 2,
      },
    ];
  }

  selectTripDirections(tripDirections: number) {
    this.selectedTripDirections = tripDirections;
    this.$emit('input', this.selectedTripDirections);
  }

}
